var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgCart(_ref) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 28,
    height: 28,
    viewBox: "0 0 28 28",
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    d: "M25.52 7H7.26L6.9 3.89C6.68 2.24 5.67 1 4 1H1c-.61 0-1 .39-1 1s.39 1 1 1h3c.537 0 .626.601.704 1.133l.006.037L6.39 17a3.44 3.44 0 003.33 3h11.72a3.44 3.44 0 003.31-2.81l1.86-8.76c.07-.32-.02-.76-.23-1.02-.21-.26-.52-.41-.86-.41zM7.55 8.87l1.06 8.02c.08.56.57.99 1.15.98h12.02c.54 0 1.02-.37 1.13-.9l1.64-8.1h-17zm-.89 15.45a2.22 2.22 0 104.44 0 2.22 2.22 0 00-4.44 0zm12.31 0a2.22 2.22 0 104.44 0 2.22 2.22 0 00-4.44 0z",
    clipRule: "evenodd"
  })));
}

export default SvgCart;